import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = () => {
  const [series] = useState([
    {
      name: "Data",
      data: [2, 3, 10, 11, 8, 5, 7, 5, 4, 3, 2],
    },
  ]);

  const [options] = useState({
    chart: {
      type: "area",
      height: 350,
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      width: 4,
      colors: ["#0052CC"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.9,
        opacityTo: 0.1,
        stops: [0, 100],
        colorStops: [
          {
            offset: 0,
            color: "#67C8FF",
            opacity: 0.7,
          },
          {
            offset: 100,
            color: "#0052CC",
            opacity: 0.3,
          },
        ],
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#143A62",
          fontSize: "16px",
        },
      },
    },
    yaxis: {
      min: 0,
      max: 12,
      tickAmount: 6,
      labels: {
        style: {
          colors: "#143A62",
          fontSize: "16px",
        },
        formatter: function (val) {
          return val.toFixed(0);
        },
      },
    },
    grid: {
      borderColor: "#C9CBCD",
      strokeDashArray: 5,
    },
    tooltip: {
      enabled: true,
    },
    markers: {
      size: 0, // No visible markers
    },
    dataLabels: {
      enabled: false, // 🚀 Hides the numbers on the graph
    },
  });

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={350}
      />
    </div>
  );
};

export default LineChart;
